import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  PRACTICE_SETUP_WIZARD_STATUS_COLOUR_MAP,
  PracticeSetupWizardStatus,
} from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-practice-setup-wizard-status',
  templateUrl: './practice-setup-wizard-status.component.html',
  styleUrls: ['./practice-setup-wizard-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, StatusLabelComponent],
  host: { class: 'flex' },
})
export class PracticeSetupWizardStatusComponent {
  dense = input(false, { transform: coerceBooleanProperty });
  status = input.required<PracticeSetupWizardStatus>();
  statusColor = computed(
    () => PRACTICE_SETUP_WIZARD_STATUS_COLOUR_MAP[this.status()]
  );

  statusLabel = computed(() => this._computeStatusLabel());

  private _computeStatusLabel(): string {
    const status = this.status();
    switch (status) {
      case PracticeSetupWizardStatus.NotStarted:
        return 'Not Started';
      case PracticeSetupWizardStatus.InProgress:
        return 'In Progress';
      case PracticeSetupWizardStatus.Complete:
        return 'Complete';
      default:
        return status;
    }
  }
}
